import "./DefaultFlag.scss";

// Defaults to US Flag
export const DefaultFlag = () => {
  return <span className="default-flag-icon"></span>;
};
